import React, {useState} from "react";
import {Row, FormControl, InputGroup} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import {useUpdateEffect} from './lib/customHooks';
import debounce from 'lodash/debounce';
const style = Object.freeze({maxWidth: 180});

export const rejectEmptyValue = obj =>
  Object.keys(obj)
    .filter(k => obj[k] !== undefined)
    .reduce((acc, k) => ({...acc, [k]: obj[k]}), {});

const SearchDateRange = props => {
  const [range, setRange] = useState({[props.startName]: props.start || '', [props.endName]: props.end || ''});
  const [jqxhr, setJqxhr] = useState(null);

  const fetch = debounce((q) => {
    if (jqxhr) {
      jqxhr.abort();
    }

    updateQueryString(rejectEmptyValue(q));

    const options = {
      type: 'GET',
      url: props.url,
      data: {...queryStringToHash(), ...rejectEmptyValue(q)}
    };
    setJqxhr($.ajax(options));
  }, 500);

  const handleChange = e => {
    e.persist();
    setRange(old => ({...old, [e.target.name]: e.target.value}));
  };

  useUpdateEffect(() => { fetch(range); }, [range]);

  return (
    <InputGroup className="align-items-center">
      <InputGroup.Text>{props.label}</InputGroup.Text>
      <FormControl
        type="date"
        placeholder="開始"
        style={style}
        name={props.startName}
        defaultValue={range[props.startName]}
        onChange={handleChange} />
      ～
      <FormControl
        type="date"
        placeholder="終了"
        style={style}
        name={props.endName}
        defaultValue={range[props.endName]}
        onChange={handleChange} />
    </InputGroup>
  );
}

export default SearchDateRange;
